import React from 'react'

export default function Input(props) {
    return (
        <div className="relative w-full">
            {props.Icon &&
                <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none text-gray-400">
                    {props.Icon}
                </div>
            }
            <input {...props} className={(props.Icon ? "pl-11 " : "pl-4 ") + (props.isError ? "text-box-error" : "text-box")} />
        </div>
    )
}
